var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeVolta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#00468B",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2339 4783 c-64 -31 -2296 -1633 -2315 -1660 -40 -62 -27 -139 33 -194 30 -28 2205 -1582 2263 -1618 74 -45 174 -17 212 59 16 32 18 75 18 455 l0 421 68 -4 c110 -5 299 -31 432 -58 268 -55 597 -189 815 -331 466 -305 805 -780 935 -1308 38 -153 51 -179 105 -205 52 -25 78 -25 131 1 32 15 48 32 65 66 21 44 22 53 16 237 -19 562 -111 1040 -279 1456 -161 396 -359 694 -654 980 -254 246 -543 430 -887 565 -205 80 -500 155 -674 171 l-72 7 -3 438 c-3 424 -4 438 -24 465 -50 67 -120 89 -185 57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeVolta);
export default __webpack_public_path__ + "static/media/de-volta.4388e4b278f11356e50cdd35a3c3adc2.svg";
export { ForwardRef as ReactComponent };